<template>
  <div>
    <SyncStatsContainer v-slot="{ stats }">
      <Message
        v-if="stats && stats.demoMode"
        severity="warn"
        :closable="false"
        class="tw-mb-4"
      >
        Job-history DB unavailable — showing live warehouse inventory only (no fake sync charts). Check <code>DATABASE_URL</code>.
      </Message>
      <Message
        v-else-if="stats && (stats.warehouseFeeds || []).some(w => w.listingCount > 0)"
        severity="info"
        :closable="false"
        class="tw-mb-4"
      >
        Showing live listings warehouse inventory (what Brokurz sites use). Job-history charts fill in when syncs run from the Jobs UI.
      </Message>
      <p class="tw-text-muted tw-mb-4 tw-text-sm">
        Sync volume, feed health, and recent activity across your MLS sources.
      </p>
      <DashboardHome :stats="stats" />
    </SyncStatsContainer>
  </div>
</template>

<script>
import SyncStatsContainer from './SyncStatsContainer'
import DashboardHome from './DashboardHome'

export default {
  components: {
    SyncStatsContainer,
    DashboardHome,
  },
}
</script>
